import axios from './HTTP'

export default {
  getAll (userId, callback) {
    axios
      .get('/api/worksites.json', { params: { user_id: userId } })
      .then(response => ( callback(response.data) ))
  },

  getAtLocation (locationId, callback, errorCallback) {
    axios
      .get(`/api/worksites/${ locationId }/team_members.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  getIneligibleAtLocation (locationId, callback, errorCallback) {
    axios
      .get(`/api/worksites/${ locationId }/ineligible_team_members.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  updateTeamsAt (params, callback, errorCallback) {
    axios
      .patch(`/api/worksites/${ params.locationId }/team_members.json`, {
        employee_ids: params.employeeIds
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  updateIneligibleTeamsAt (params, callback, errorCallback) {
    axios
      .patch(`/api/worksites/${ params.locationId }/ineligible_team_members.json`, {
        ineligible_employees: params.ineligible_employees
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  addIneligibleTeamMembers (params, callback, errorCallback) {
    axios
      .post(`/api/worksites/${ params.locationId }/add_ineligible_team_members.json`, params)
      .then(response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  removeIneligibleTeamMembers (params, callback, errorCallback) {
    axios
      .patch(`/api/worksites/${ params.locationId }/remove_ineligible_team_members.json`, params)
      .then(response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  }

}
